// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Vqitt","top":"styles_top__yvwyp","left":"styles_left__2xk4g","description":"styles_description__13QBH"};